let handler = null;

export function setNotificationHandler(fn) {
  handler = fn;
}

export function notify(message, severity, options) {
  if (handler) {
    handler(message, severity, options);
  } else {
    console.warn("[notificationService] No handler registered:", message);
  }
}
